import { last, values, intersection, uniq } from 'lodash';
import reduxStore from "./reduxStore";

const userRights = () => reduxStore.getState().user.permissions || [];

export const permissions = {
    entities:   { view: "ENTITY_VIEW",  edit: "ENTITY_EDIT" },
    categories: { view: "CAT_VIEW",     edit: "CAT_EDIT" },
    alerts:     { view: "ALERTS_VIEW",  edit: "ALERTS_EDIT" },
    feeds:      { view: "FEEDS_VIEW",   edit: "FEEDS_EDIT" },
    admin:      { view: "ADMIN" }
}

const permissionGroups = {
    "ENTITY_ADMIN": [
        ...values(permissions.entities),
    ],
    "CATEGORY_ADMIN": [
        ...values(permissions.categories),
    ],
    "ALERT_ADMIN": [
        ...values(permissions.alerts),
    ],
    "RSS_ADMIN": [
        ...values(permissions.feeds),
    ],
    "DASHBOARD_VIEW": [
        ...values(permissions.admin)
    ]
}

const defaultPermissions = [
    permissions.entities.view,
    permissions.categories.view,
    ...values(permissions.alerts),
    ...values(permissions.feeds)
]

/**
 * define paths protected by permissions. can accept permissions as string(single permission) or object (group of permissions)
 * or array (multiple permissions)
 * @type {{/[path]: string/object/array}}
 */
export const pathPermissions = {
    '/review-companies': permissions.entities.edit,
    '/upload': permissions.entities.edit,
    '/preview-company/:companyId': permissions.entities.edit,
    '/preview-company/:companyId/:articleId/:articleIndex/:backRoute': permissions.entities.edit,

    '/manage-third-parties': permissions.entities,
    '/edit-third-party/:companyId': permissions.entities.edit,
    '/create-new-entity': permissions.entities.edit,

    '/categories': permissions.categories,
    '/create-category': permissions.categories.edit,
    '/categories/:categoryId': permissions.categories.edit,

    '/email-alerts': permissions.alerts,
    '/email-alerts/:alertId': permissions.alerts.edit,
    '/create-new-alert': permissions.alerts.edit,

    '/feeds': permissions.feeds,
    '/edit-feed/:feedId': permissions.feeds.edit,
    '/add-new-feed': permissions.feeds.edit,

    '/account': permissions.admin.view,
    '/audit': permissions.admin.view,
}

/**
 * Returns if user has certain permission(s). If multiple permissions, will return true if at least one is true
 * @param action - string(single permission) or object (group of permissions) or array (multiple permissions)
 * @returns {boolean}
 */
export function userHas(action) {
    const permissions = [ ...composePermissions(userRights()), ...defaultPermissions];

    if (typeof action === "string") { // individual action
        return permissions.indexOf(action) > -1;
    } else { // any action in group
        const permissionList = values(action);
        return intersection(permissionList, permissions).length > 0;
    }
}

export function routeCheckPermission(prevState, nextState, redirect) {
    const path = last(nextState.routes).path;
    if (pathPermissions[path] && !userHas(pathPermissions[path])) {
        redirect({ location: "/start" });
    }
}

function composePermissions(rights) {
    let permissions = [];
    rights.forEach(right => {
        // only pick up permissions we support
        if (permissionGroups[right]) {
            permissions.push(...permissionGroups[right])
        }
    });
    return uniq(permissions);
}



// WEBPACK FOOTER //
// ./src/scripts/permissions.js